import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import HomeApp from '../../../jsV2/home/app/App';
import HelpApp from '../components/HelpApp';
import { parseResourceInfoFromLocation } from '../../lib/location-helper';
import { isLoggedIn, isNewHomeExpEnabled } from '../../../jsV2/helpers/twHelper';
import { newExperienceFPTIs } from '../../../jsV2/helpers/analytics/appLevelAnalytics';
import { trackActivityEvent } from '../../../jsV2/helpers/analytics/fptiHelper';
import {
  isBotExperienceEnabled,
  isShowOnlySearchLayoutEnabled,
  isHomeExpTransactionLayoutEnabled,
} from '../../../experimentations/helper';

const isHomeV2Enabled = isNewHomeExpEnabled();
const newExperienceEnabledRoutes = ['home'];

function LayoutRenderer(props) {
  const { sideBar, mainContainer } = props;
  const { pathname } = useSelector((state) => state.location);

  const renderOldLayout = () => <HelpApp sideBar={sideBar} mainContainer={mainContainer} />;

  const renderLayout = () => {
    try {
      if (isLoggedIn()) {
        const currentLocationName = parseResourceInfoFromLocation({ pathname });
        const newExperience = isHomeV2Enabled && newExperienceEnabledRoutes.indexOf(currentLocationName.name) >= 0;
        const InnovationExperience =
          (isBotExperienceEnabled() || isShowOnlySearchLayoutEnabled() || isHomeExpTransactionLayoutEnabled()) &&
          newExperienceEnabledRoutes.indexOf(currentLocationName.name) >= 0;
        if (InnovationExperience || newExperience) {
          return <HomeApp>{mainContainer}</HomeApp>;
        }
        return renderOldLayout();
      }
      return renderOldLayout();
    } catch (e) {
      trackActivityEvent(newExperienceFPTIs.newHomeExperienceError);
      return renderOldLayout();
    }
  };

  return renderLayout();
}
LayoutRenderer.propTypes = {
  sideBar: PropTypes.element.isRequired,
  mainContainer: PropTypes.element.isRequired,
};

export default LayoutRenderer;
